// Create the importer object
const importer = {
  isRunning: false,
}

// Setup function for Vue 3
export const setupImporter = app => {
  app.config.globalProperties.$importer = importer
}

export default importer
